import { PropsWithChildren } from 'react'
import ApplicationLogo from '@/Components/Assets/ApplicationLogo'
import FlashMessages from '@/Components/Feedback/FlashMessages'

export default function GuestLayout({ children }: PropsWithChildren) {
    return (
        <div className="flex min-h-screen flex-col items-center bg-gray-100 pt-6 sm:justify-center sm:pt-0">
            <div>
                <a href="/">
                    <ApplicationLogo className="w-[550px] max-w-full fill-current" />
                </a>
            </div>

            <div className="mt-6 w-full overflow-hidden bg-white px-6 py-4 shadow-md sm:max-w-md sm:rounded-lg">{children}</div>

            <FlashMessages />
        </div>
    )
}
